import PropTypes from 'prop-types'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import useAgencyProviderPackage from '@hooks/useAgencyProviderPackage'
import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls, useRelations } from '@hooks/useProviderPackage'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

const AgencyPackageListItem = (props) => {
  const {
    agencyProviderPackage: initAgencyProviderPackage,
    ...restProps
  } = props

  const {
    providerPackage,
    providerPackage: {
      price,
      product_code,
      title,
    },
  } = useAgencyProviderPackage(initAgencyProviderPackage)

  const {
    provider: {
      title: providerTitle,
    },
  } = useRelations(providerPackage)

  const { editProviderPackageUrl } = generateUrls(providerPackage)

  const { isBrandUser } = useCurrentUser()

  return (
    <DashboardModuleListItem
      showCheckbox={!isBrandUser}
      secondaryText={providerTitle}
      title={title}
      {...restProps}
    >
      <Box alignItems="end" display={['none', 'flex']} flexDirection="column">
        <Text>${price}</Text>

        {!!product_code && (
          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            marginTop="small"
          >
            {product_code}
          </Text>
        )}
      </Box>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        <DashboardModuleListItem.Actions>
          <DashboardModuleListItem.Icon
            href={`${editProviderPackageUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

AgencyPackageListItem.propTypes = {
  agencyProviderPackage: PropTypes.object.isRequired,
}

export default AgencyPackageListItem
